// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"167":"dd113bb5ce3061b1","247":"cd5284b1942c824b","357":"306803eae5fda8e9","400":"1e655924ffe14a8e","464":"1a7d9b4c89a04c52","545":"15b0f906ccf59df7","610":"1f6385bf4db94374","671":"7957d87fea5d977c"}[chunkId] + ".js";
};